// removed by extract-text-webpack-plugin
module.exports = {"newReference":"NewReference__newReference___aeoHl","title":"NewReference__title___PU9_u","form":"NewReference__form___2npTx","input":"NewReference__input___3HFx3","button":"NewReference__button___ycv36"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/memberApprovedProfile/profile/components/references/newReference/NewReference.scss
// module id = 1565
// module chunks = 0